import { combineReducers, Reducer } from "redux";

import { ConditionParams } from "@multiweb/clients/dataReader";
import { DATA_SOURCE_INIT_STATE } from "../initState";
import {
    IDataSourceConditions,
    IFulltextSearchCondition,
    IInitDataSourceAction,
    IUpdateFulltextDataSourceCondition,
    IUpdateMasterFrameDataSourceCondition,
} from "../types";

const condition: Reducer<string> = (
    state = DATA_SOURCE_INIT_STATE.conditions.condition,
    action,
) => {
    if (action instanceof IInitDataSourceAction) {
        return action.payload.conditions?.condition ?? state;
    }
    return state;
};

const fulltextCondition: Reducer<IFulltextSearchCondition> = (
    state = DATA_SOURCE_INIT_STATE.conditions.fulltextCondition,
    action,
) => {
    if (action instanceof IInitDataSourceAction) {
        return action.payload.conditions?.fulltextCondition ?? state;
    } else if (action instanceof IUpdateFulltextDataSourceCondition) {
        return action.payload.newCondition;
    }
    return state;
};

const masterFrameCondition: Reducer<string> = (
    state = DATA_SOURCE_INIT_STATE.conditions.masterFrameCondition,
    action,
) => {
    if (action instanceof IInitDataSourceAction) {
        return action.payload.conditions?.masterFrameCondition ?? state;
    } else if (action instanceof IUpdateMasterFrameDataSourceCondition) {
        return action.payload.newCondition;
    }
    return state;
};

const conditionParams: Reducer<ConditionParams> = (
    state = DATA_SOURCE_INIT_STATE.conditions.conditionParams,
    action,
) => {
    if (action instanceof IInitDataSourceAction) {
        return action.payload.conditions?.conditionParams ? [...action.payload.conditions.conditionParams] : state;
    } else if (action instanceof IUpdateMasterFrameDataSourceCondition) {
        return action.payload.conditionParams && [...action.payload.conditionParams];
    }
    return state;
};

export const conditionsReducer: Reducer<IDataSourceConditions> = combineReducers({
    condition,
    fulltextCondition,
    masterFrameCondition,
    conditionParams,
});
